<!-- <p>url = {{url3_5}}</p><p>legacyWebUi - {{legacyWebUI}}</p><p>listSpec = {{listSpec}}</p>   -->
<span lm-live-region [liveRegionConfig]="liveMessageToast"></span>
<span lm-live-region [liveRegionConfig]="liveMessageList"></span>
@if (legacyWebUI && url3_5) {
    @if (unsupportedPattern && !isProduction) {
        <p style="font-weight: bold; color:red; height: 20px;text-align: center; position:absolute; width:100%">
            CURRENTLY UNSUPPORTED SOHO XI PATTERN DETECTED
        </p>
    }
    <lm-html-url-doc
        [url]="url3_5"
        [showLoading]="false"
        (titleChanged)="onTitleChanged($event)">
    </lm-html-url-doc>
}

@if (initialBuildComplete && !url3_5) {
    @if (routeReuseMode && isRouterOutletRootComponent && lmContextService.isDeveloper()) {
        <div class="font-size-px-16 route-reuse-indicator"
            soho-tooltip
            [content]="'Screen Display Time / First Load Template Time - Loadtime Times Improved<br> <br> Green = Template in use.<br>  Blue = Template not available and will be saved'"
            [class.route-reuse-indicator-active]="hasStoredRoute()">
            Route Reuse {{hasStoredRoute() ? 'Active': ''}} - {{displayLoadTime()}} / {{getRouteReuseTemplateLoadTime()}} - {{getSpeedIncrease()}} x+
        </div>
    }

    @if (implementsCancellablePaging && showCancellableNotification) {
        <lm-notification
            [isVisible]="showCancellableNotification"
            [notificationType]="'info'"
            [message]="cancelablePagingMessage"
            [actionMessage]="cancelablePagingActionMessage"
            (lmNotificationEvent)="onLMNotificationEvent($event)">
        </lm-notification>
    }

    @if (topLevelOverlayComponent) {
        <div [class.header-border]="true"
            [class.overlay-toolbar]="true">
            <lm-toolbar
                [toolbarIdPrefix]="screenId"
                [automationId]="screenAutomationId"
                [inHeader]="false"
                [isInOverlay]="true"
                [showOverlayBackButton]="showOverlayBackButton"
                [sectionTitle]="overlayTitle"
                [allowOverlayInteractions]="false"
                [buttons]="overlayButtons | async"
                [showCalledOutMenuButton]="showCalledOutMenuButton"
                [style.padding-right.px]="3"
                (appMenuTriggerEvent)="onAppMenuTriggerEvent($event)"
                (toolbarButtonEvent)="onToolbarButtonEvent($event)"
                (toolbarSearchEvent)="onToolbarSearchEvent()"
                (toolbarSearchClearedEvent)="onToolbarSearchClearedEvent()">
            </lm-toolbar>
        </div>
    }

    @if (bannerInRoute && isCardViewWithDetailSections) {
        <div soho-busyindicator
            style="flex-direction: column"
            [text]="' '"
            [displayDelay]="20"
            [overlayOnly]="true"
            [timeToComplete]="this.uiLoadingIndicatorTimeout">
            @if (isCubeView) {
                <ng-container *ngTemplateOutlet="cubeView"></ng-container>
            } @else {
                <ng-container *ngTemplateOutlet="regularList"></ng-container>
            }
        </div>
    }

    @if (!bannerInRoute || (bannerInRoute && !isCardViewWithDetailSections)) {
        <div soho-busyindicator
            [text]="' '"
            [displayDelay]="20"
            [overlayOnly]="true"
            [timeToComplete]="this.uiLoadingIndicatorTimeout"
            [class.overlay-top-level]="topLevelOverlayComponent"
         [class.scrollable]="topLevelOverlayComponent"
         [class.search-form-on-left]="searchFormOnLeft">
            @if (isCubeView) {
                <ng-container *ngTemplateOutlet="cubeView"></ng-container>
            } @else {
                <ng-container *ngTemplateOutlet="regularList"></ng-container>
            }
        </div>
    }

    <!-- CUBES -->
    <ng-template #cubeView>
        <div [ngClass]="standardCubeListClasses">
            <div class="lmc no-scroll" [ngClass]="cubeListContainerClasses">
                @if (bannerInRoute && isRouterOutletRootComponent) {
                    <soho-header #SohoHeader [hasTabs]="false" [hasToolbar]="false">
                        <ng-container *ngTemplateOutlet="ToolbarMarkup"></ng-container>
                    </soho-header>
                }
                @if (hasSearchForm) {
                    <lm-form
                        [ngClass]="{ 'hidden' : !((!displaySearchInDialog && showSearchForm) || !searchFormIsAlways), 'search-form-card-view-with-details': isCardViewWithDetailSections }"
                        [formUrlInfo]="searchFormUrlInfo"
                        [formSpec]="searchFormSpec"
                        [initDataView]="searchFormDataView"
                        [formOptions]="searchFormOptions"
                        [isInOverlay]="isInOverlay || topLevelOverlayComponent"
                        [style.display]="showSearchForm || searchFormIsAlways ? 'block' : 'none'"
                        (cubeSearchOpenLookupEvent)="onCubeSearchOpenLookup($event)"
                        (searchButtonClicked)="onSearchClicked($event)"
                        (clearSearchButtonClicked)="onClearSearchClicked($event)"
                        (formDisplayed)="onSearchFormDisplayed()">
                    </lm-form>
                    <div #SearchFormPlaceholder></div>
                    @if (!showSearchForm && !searchFormIsAlways && hasSearchTags) {
                        <lm-list-searchtags
                            [automationIdPrefix]="searchFormSpec.automationId"
                            [searchTags]="searchTags"
                            (searchTagRemoved)="onSearchTagRemoved($event)"
                            (clearFilter)="onClearSearchTags()"
                            (refineFilter)="onRefineFilter()">
                        </lm-list-searchtags>
                    }
                }
                <lm-list-content
                    attr.id="{{testVersion1 ? listSpec?.busListSpec?.id : null}}"
                    [style.height]="this.lmContextService.inMingleWidget() ? 'calc(100% - 45px)' : '100%'"
                    [listUrlInfo]="listUrlInfo"
                    [listSpec]="listSpec"
                    [disabled]="disabled"
                    [fromDataView]="fromDataView"
                    [displayType]="displayType"
                    [chartName]="chartName"
                    [filterCriteria]="filterCriteria"
                    [columnfilterOperators]="columnfilterOperators"
                    [filterListFilterCriteria]="filterListFilterCriteria?.filterCriteria"
                    [hasFilterList]="hasFilterList"
                    [sortOrder]="sortOrder"
                    [selectRequestData]="selectRequestData"
                    [showFilter]="showFilter"
                    [listState]="listState"
                    [listPersonalization]="listPersonalization"
                    [isDashBoardContent]="isDashBoardContent"
                    [allowOverlayInteractions]="allowOverlayInteractions"
                    [reportAsOfDate]="reportAsOfDate">
                </lm-list-content>
            </div>
            <ng-container [ngTemplateOutlet]="ListDetailContent"></ng-container>
        </div>
    </ng-template>

    <ng-template #regularList>
        @if (searchFormOnLeft) {
            <div [ngClass]="{'lm-search-form-on-left': true}" [style.display]="showSearchForm || searchFormIsAlways ? 'block' : 'none'">
                <ng-container *ngTemplateOutlet="SearchForm"></ng-container>
            </div>
        }
        @if (isCardViewWithDetailSections) {
            <ng-container *ngTemplateOutlet="cardListDetails"></ng-container>
        } @else {
            <ng-container *ngTemplateOutlet="standardList"></ng-container>
        }
    </ng-template>

    <!--
      LIST WITH STANDARD DETAIL SECTIONS
      NOTE: DON'T need height 100% now that it's just for standard list and standard detail sections: [style.height]="'100%'"
    -->
    <ng-template #standardList>
        <div [ngClass]="standardListClasses" [class.detail-side]="showListDetailOnSide">
            <div class="lm-list-container lmc" [ngClass]="listContainerClasses" [class.no-scroll]="!showListDetailOnSide">
                <ng-container [ngTemplateOutlet]="ListMainContent"></ng-container>
            </div>
            <div [ngClass]="{'detail-content-side': showListDetailOnSide}">
                <ng-container [ngTemplateOutlet]="ListDetailContent"></ng-container>
            </div>
        </div>
    </ng-template>

    <!--
      CARD LIST WITH DETAIL SECTIONS ON THE SIDE
    -->
    <ng-template #cardListDetails>
        @if (bannerInRoute && isRouterOutletRootComponent) {
            <soho-header #SohoHeader [hasTabs]="false" [hasToolbar]="false" style="min-height: 60px;" class="lm-header-card-list">
                <ng-container *ngTemplateOutlet="ToolbarMarkup; context: { setInHeader: true }"></ng-container>
            </soho-header>
        }

        <lm-drawer
            [showDetails]="showDetails$ | async"
            [showDetailsOnSide]="showDetailsOnSide"
            [additionalClasses]="drawerAdditionalClasses">
            <lm-drawer-side class="lm-list-container lmc no-scroll sidebar" [collapsed]="drawerCollapse$ | async">
                <ng-container [ngTemplateOutlet]="ListMainContent"></ng-container>
            </lm-drawer-side>

            <lm-drawer-side-collapsed [collapsed]="drawerCollapse$ | async">
                <ng-container [ngTemplateOutlet]="CollapsedList"></ng-container>
            </lm-drawer-side-collapsed>

            <lm-drawer-content class="main" [class.scrollable]="hasContextCardView">
                <ng-container [ngTemplateOutlet]="ListDetailContent"></ng-container>
            </lm-drawer-content>
        </lm-drawer>
    </ng-template>

    <ng-template #CollapsedList>
        @if (isAbovePhoneView$ | async) {
            <div class="collapsed-list-title">
                <h2 soho-tooltip title="{{listTitle}}">{{listTitle}}</h2>
                <!-- disable the more button for now -->
                <!-- <button id="{{ listSpec?.busListSpec?.id }}_collapsed_menu_button"
                  soho-button="icon"
                  icon="more"
                  class="btn-actions"
                  soho-context-menu
                  menu="{{ listSpec?.busListSpec?.id }}_collapsed_menu"
                  trigger="click"
                  [beforeOpen]="onBeforeListToolbarMoreMenuOpen"
                  (selected)="onContextMenuItemSelected($event)">
                </button> -->
                <span class="separator"></span>
                @if (selectedDataView) {
                    <h3 soho-tooltip
                        title="{{selectedDataView.representativeText}}">
                        {{selectedDataView.representativeText}}
                    </h3>
                }
            </div>
        }
        <button id="{{ listSpec?.busListSpec?.id }}_collapsed_button"
            soho-button="icon"
            icon="expand-app-tray"
            [ripple]="false"
            (click)="expandDrawerSide()"
            attr.data-automation-id="lm-{{screenAutomationId}}-expand-button"
            aria-label="{{ 'ReportFieldPickerDrawerExpand' | translate }}">
        </button>
    </ng-template>

    <ng-template #ListMainContent>
        <div class="scrollable-flex" [style.height]="listContainerContentStyleHeight">
            <div [ngClass]="{'scrollable-flex-header': true, 'panel-header card-header': isFilterList, 'show-search-form' : showSearchForm}">
                @if (allowMaintainingSelectedValues || inSelectListEditMode) {
                    <lm-list-selectiontags #ListSelectionTags
                        [displaySelectionTags]="(allowMaintainingSelectedValues) ? showMultiSelectTags : false"
                        [automationIdPrefix]="screenAutomationId"
                        [selectionTags]="selectionTags"
                        (selectionTagRemoved)="onSelectionTagRemoved($event)">
                    </lm-list-selectiontags>
                }
                @if (displayToolbar) {
                    <!--
                    [searchField]="!isCardViewWithDetailSections ? toolbarSearchField : null"
                    DON'T set search field if using the card with detail sections pattern. Another component
                    manages the search field in this scenario
                    -->
                    @if (bannerInRoute && isRouterOutletRootComponent && !isCardViewWithDetailSections) {
                        <soho-header #SohoHeader [hasTabs]="false" [hasToolbar]="false">
                            <ng-container *ngTemplateOutlet="ToolbarMarkup"></ng-container>
                        </soho-header>
                        @if (toolbarAboveList && !isCardViewWithDetailSections) {
                            <ng-container *ngTemplateOutlet="ToolbarMarkup; context: { bannerInRouteListToolbar: true }"></ng-container>
                        }
                    } @else {
                        <ng-container *ngTemplateOutlet="ToolbarMarkup"></ng-container>
                    }

                    @if (isFilterList) {
                        <h2 class="card-title" soho-tooltip [title]="listTitle">{{listTitle}}</h2>
                        <button soho-button="btn"
                            class="btn btn-close list-detail-list-close-button"
                            [icon]="'close'"
                            soho-tooltip
                            [title]="'Hide Filter List'">
                        </button>
                    }
                }

                @if (isDashBoardContentWithRecordCount) {
                    <header class="lm-list-header-record-count result-set-in-dashboard">{{mustacheText}}</header>
                }

                <!-- Displays panel text -->
                @if (listText) {
                    <lm-form-panel-text
                        [panelText]="listText"
                        [fromDataView]="fromDataView">
                    </lm-form-panel-text>
                }

                @if (searchFieldOnCardViewWithDetails) {
                    <div class="lm-listview-search">
                        <!-- soho controls now strip style off of the soho-searchfield-wrapper, so in this case wrap in a div and apply the width to that -->
                        <div [style.width]="hasKeywordIcons ? keywordSearchWidth : '100%'">
                            <form (ngSubmit)="onListViewSearchFieldEvent()" class="lm-searchfield-form">
                            <span soho-searchfield-wrapper attr.data-automation-id="lm-{{screenAutomationId}}-searchfield-wrapper">
                                <input soho-searchfield
                                    #SearchField
                                    placeholder="{{searchPlaceholder}}"
                                    attr.data-automation-id="lm-{{screenAutomationId}}-searchfield"
                                    enterkeyhint="search"
                                    [(ngModel)]="listViewSearchFieldValue"
                                    [ngModelOptions]="{standalone: true}">
                            </span>
                            </form>
                        </div>
                        @if (hasScannableKeyword) {
                            <button (click)="onBarCodeClick()">
                                <svg soho-icon [icon]="'barcode'"></svg>
                            </button>
                        }
                        @if (hasSearchForm && !searchFormIsAlways) {
                            <button (click)="onFilterButtonClicked()"
                                title="{{'FilterSearch' | translate}}"
                                attr.data-automation-id="lm-{{screenAutomationId}}-searchfield-filter-button"
                                attr.aria-label="{{'FilterSearch' | translate}}"
                                attr.aria-expanded="{{showSearchForm || searchFormIsAlways ? 'true' : 'false'}}">
                                <svg soho-icon [icon]="'filter'"></svg>
                            </button>
                        }
                    </div>
                }

                @if (!searchFormOnLeft) {
                    <ng-container *ngTemplateOutlet="SearchForm"></ng-container>
                }
                <ng-container *ngTemplateOutlet="listTags"></ng-container>
            </div>

            @if (columnarSubTitle) {
                <span class="columnar-refreshed-text">{{columnarSubTitle}}</span>
            }

            <div class="scrollable-flex-content" [ngClass]="detailFieldsClass">
                <lm-list-content
                    lm-drag-and-drop
                    [isAttachmentList]="isAttachmentList"
                    (filesDropped)="onFilesDropped($event)"
                    attr.id="{{testVersion1 ? listSpec?.busListSpec?.id : null}}"
                    class="main-list"
                    [listUrlInfo]="listUrlInfo"
                    [listSpec]="listSpec"
                    [fromDataView]="fromDataView"
                    [displayType]="displayType"
                    [chartName]="chartName"
                    [adhocReportMode]="adhocReportMode"
                    [openAdhocReportOverlay]="openAdhocReportOverlay"
                    [implementsCartView]="usedInCartView"
                    [filterCriteria]="filterCriteria"
                    [columnfilterOperators]="columnfilterOperators"
                    [filterListFilterCriteria]="filterListFilterCriteria?.filterCriteria"
                    [hasFilterList]="hasFilterList"
                    [implementsDragAndDrop]="implementsDragAndDrop"
                    [sortOrder]="sortOrder"
                    [selectRequestData]="selectRequestData"
                    [showFilter]="showFilter"
                    [listState]="listState"
                    [listPersonalization]="listPersonalization"
                    [isDashBoardContent]="isDashBoardContent"
                    [disabled]="disabled"
                    [implementsManualLoad]="implementsManualLoad"
                    [manualLoadInfo]="manualLoadInfo"
                    [multiSelectedValues]="multiSelectedValues"
                    [inSelectListEditMode]="inSelectListEditMode"
                    [isInOverlay]="isInOverlay || topLevelOverlayComponent"
                    [routerOutlet]="isRouterOutletRootComponent"
                    [allowOverlayInteractions]="allowOverlayInteractions"
                    [reportAsOfDate]="reportAsOfDate"
                    [modelLpl]="modelLpl"
                    [modelUserFolder]="modelUserFolder">
                </lm-list-content>

                @if (showScanOptionsContextMenu) {
                    <div id="{{contextScanMenuId}}" class="popupmenu-wrapper" role="application">
                        <ul soho-popupmenu
                            attr.id="{{contextScanMenuId}}"
                            menu="{{contextScanMenuId}}"
                            trigger='immediate'
                            [useCoordsForClick]="true"
                            [attachToBody]="true"
                            [removeOnDestroy]="true"
                            [eventObj]="contextScanMenuEvent"
                            (selected)="contextScanMenuClicked($event)"
                            (close)="onCloseContextScanMenu($event)">
                            <li soho-popupmenu-item>
                                <a id="ScanEvent" href="javascript:void(0);" role="menuitem" tabindex="-1">{{ 'Scan' | translate }}</a>
                            </li>
                            <li soho-popupmenu-item>
                                <a id="SelectEvent" href="javascript:void(0);" role="menuitem" tabindex="-1">{{ 'Select' | translate }}</a>
                            </li>
                        </ul>
                    </div>
                }

                @if (hasDetailFields && !hasDetailSections && !implementsOrgChartView && detailFieldsFormModel) {
                    <lm-form-content-form #detailFieldsFormComponent
                        class="detail-fields"
                        attr.data-automation-id="lm-{{detailFieldsFormSpec.automationId}}-form"
                        [specFields]="detailFieldsSpecFields"
                        [formSpec]="detailFieldsFormSpec"
                        [layout]="detailFieldsFormLayout"
                        [model]="detailFieldsFormModel"
                        (fieldEvent)="onFieldEvent($event)">
                    </lm-form-content-form>
                }

                @if (showChangeValuesOnRight) {
                    <lm-list-audit-compare-panel
                        id='compare-detail-view'
                        class="compare-panel"
                        [uiLoadingIndicatorTimeout]="uiLoadingIndicatorTimeout"
                        [ngStyle]="{'visibility': dashboardVisibility }">
                    </lm-list-audit-compare-panel>
                }
            </div>
        </div>
    </ng-template>

    <ng-template #ToolbarMarkup let-setInHeader="setInHeader" let-bannerInRouteListToolbar="bannerInRouteListToolbar">
        <!--  <ng-container *ngIf="hideTitleBar">   -->
        <!--  <p>setInHeader: {{setInHeader}}, doNotShowAsHeader: {{doNotShowAsHeader}}</p>  -->
        @if (!isFilterList && !usedInCartView) {
            <lm-toolbar
                #ListToolbar
                [toolbarIdPrefix]="screenId"
                [automationId]="screenAutomationId"
                [inHeader]="bannerInRouteListToolbar ? false : setInHeader ? true : isRouterOutletRootComponent && bannerInRoute && !isCardViewWithDetailSections"
                [sectionTitle]="isCardViewWithDetailSections ? listTitle : topLevelOverlayComponent ? '' : bannerInRouteListToolbar ? '' : !isRouterOutletRootComponent || (isRouterOutletRootComponent && (!toolbarAboveList || bannerInRoute)) ? listTitle : ''"
                [searchField]="!isCardViewWithDetailSections ? toolbarSearchField : null"
                [buttons]="isCubeView && bannerInRoute ? null : toolbarButtons | async"
                [disabled]="disabled"
                [hideToolbarTitles]="listSpec.showAsMingleWidget"
                [hideOverflowMenuButton]="listSpec.showAsMingleWidget"
                [showListDetailBackButton]="hasFilterList"
                [moreMenuSettings]="toolbarMoreMenuSettings"
                [mustacheText]="mustacheText"
                [isInOverlay]="isInOverlay || topLevelOverlayComponent"
                [showOverlayBackButton]="false"
                [allowOverlayInteractions]="allowOverlayInteractions"
                [isReportAsOfDate]="isReportAsOfDate"
                [showCalledOutMenuButton]="showCalledOutMenuButton"
                [class.lm-banner-in-route-list-toolbar]="bannerInRouteListToolbar"
                [class.panel-header]="isCardViewWithDetailSections"
                [class.showSearchForm]="showSearchForm"
                [class.card-group-action]="this.listSpec.showAsMingleWidget"
                [style.padding-right.px]="3"
                (appMenuTriggerEvent)="onAppMenuTriggerEvent($event)"
                (toolbarButtonEvent)="onToolbarButtonEvent($event)"
                (toolbarSearchEvent)="onToolbarSearchEvent()"
                (toolbarSearchClearedEvent)="onToolbarSearchClearedEvent()"
                (updateReportAsOfDateEvent)="onUpdateReportAsOfDateEvent()">
            </lm-toolbar>
        }
        <!--  </ng-container>  -->
    </ng-template>

    <ng-template #ListDetailContent>
        @if (hasContextCardView && selectedDataView) {
            <lm-list-card
                #LMListCard
                class="lm-context-card-view"
                [class.context-card-borders]="!isCardViewWithDetailSections && !showListDetailOnSide"
                [listSpec]="listSpec"
                [dataView]="selectedDataView"
                [isContextCardView]="true"
                (uiLinkEvent)="onUILinkEvent($event)"
                (toolbarButtonEvent)="onToolbarButtonEvent($event)">
            </lm-list-card>
        }

        @if (isDetailDashboardView && selectedDataView) {
            <lm-dashboard-view
                id='detail-dashboard-view'
                [ngClass]="{ 'lm-list-detail bottom' : !isCardViewWithDetailSections, 'main': isCardViewWithDetailSections, 'scrollable': true}"
                [ngStyle]="{ 'visibility': dashboardVisibility, height: '100%'}"
                [columns]="listSpec.busListSpec.dashboardColumns"
                [dashboardPanels]="detailSectionPanels"
                [fromDataView]="selectedDataView"
                [refreshAfterInit]="true"
                [isFlyoutContent]="isInOverlay || topLevelOverlayComponent"
                (uiLinkEvent)="onUILinkEvent($event)"
                (contentModified)="onContentModified($event)"
                (dashboardContentDisplayed)="onPanelContentDisplayed($event)"
                (sendContextMessageEvent)="onSendContextMessageEvent($event)">
            </lm-dashboard-view>
        }

        @if (isDetailTwelveColumnGridView && selectedDataView) {
            <lm-twelve-column-grid
                id='detail-twelve-column-grid'
                [ngClass]="{ 'lm-list-detail bottom' : !isCardViewWithDetailSections, 'main': isCardViewWithDetailSections, 'scrollable': true}"
                [ngStyle]="{ 'visibility': dashboardVisibility, height: '100%'}"
                [dashboardPanels]="detailSectionPanels"
                [fromDataView]="selectedDataView"
                [isFlyoutContent]="isInOverlay || topLevelOverlayComponent"
                (uiLinkEvent)="onUILinkEvent($event)"
                (contentModified)="onContentModified($event)"
                (dashboardContentDisplayed)="onPanelContentDisplayed($event)"
                (sendContextMessageEvent)="onSendContextMessageEvent($event)">
            </lm-twelve-column-grid>
        }

        @if (isDetailSectionsView && selectedDataView) {
            <lm-detail-sections
                [showSinglePanelTab]="listSpec.busListSpec.showSinglePanelTab"
                [ngClass]="{ 'lm-list-detail bottom' : !isCardViewWithDetailSections, 'main': isCardViewWithDetailSections }"
                [ngStyle]="{ 'visibility': dashboardVisibility }"
                [listState]="listState"
                [detailSectionIdPrefix]="listSpec.busListSpec.id"
                [detailSectionAutomationIdPrefix]="listSpec.busListSpec.automationId"
                [detailSectionPanels]="detailSectionPanels"
                [isCardListDetailSections]="isCardViewWithDetailSections"
                [fromDataView]="selectedDataView"
                [fromListUrlInfo]="listUrlInfo"
                [hasContextCardView]="hasContextCardView"
                [overlayContent]="isInOverlay || topLevelOverlayComponent"
                (uiLinkEvent)="onUILinkEvent($event)"
                (contentModified)="onContentModified($event)"
                (panelContentDisplayed)="onPanelContentDisplayed($event)"
                (sendContextMessageEvent)="onSendContextMessageEvent($event)"
                (panelDataUpdated)="onPanelDataUpdated($event)"
                (drillAroundEvent)="onDrillAroundEvent($event)"
                (cubeDetailSectionPVPeriodEvent)="onCubeDetailSectionPVPeriodEvent($event)">
            </lm-detail-sections>
        }
    </ng-template>

    <!--
      id="{{contextMenuId}}" - Need a dynamic id due to datagrid needing to lookup the menu ul by it's id for a context menu.
    -->
    @if (displayContextMenu) {
        <ul soho-popupmenu
            attr.id="{{contextMenuId}}"
            menu="{{contextMenuId}}"
            [ngClass]="{'is-context-menu': displayContextMenu, 'has-checked-item': inSelectListEditMode}"
            trigger='immediate'
            [attachToBody]="true"
            [attributes]=contextMenuAttributes
            [removeOnDestroy]="true"
            [eventObj]="contextMenuEvent"
            (selected)="onContextMenuItemSelected($event)"
            (close)="onCloseContextMenu($event)"
            [beforeOpen]="onBeforeContextMenuOpen"
            (keydown)="onKeyDown($event)">
        </ul>
    }
}

<ng-template #SearchForm>
    @if (hasSearchForm) {
        <lm-form
            [ngClass]="{ 'hidden' : !((!displaySearchInDialog && showSearchForm) || !searchFormIsAlways), 'search-form-card-view-with-details': isCardViewWithDetailSections }"
            [formUrlInfo]="searchFormUrlInfo"
            [formSpec]="searchFormSpec"
            [initDataView]="searchFormDataView"
            [formOptions]="searchFormOptions"
            [isInOverlay]="isInOverlay || topLevelOverlayComponent"
            [style.display]="showSearchForm || searchFormIsAlways ? 'block' : 'none'"
            (fieldEvent)="onFieldEvent($event)"
            [listUrlInfo]="listUrlInfo"
            (searchButtonClicked)="onSearchClicked($event)"
            (clearSearchButtonClicked)="onClearSearchClicked($event)"
            (formDisplayed)="onSearchFormDisplayed()">
        </lm-form>
        <div #SearchFormPlaceholder></div>
    }
</ng-template>

<ng-template #listTags>
    @if (((hasSearchForm && !showSearchForm && !searchFormIsAlways && hasSearchTags) || (hasSearchTags && hasAdHocFilters))) {
        <lm-list-searchtags
            [idPrefix]="searchTagsIdPrefix"
            [automationIdPrefix]="searchTagsAutomationIdPrefix"
            [searchTags]="searchTags"
            (searchTagRemoved)="onSearchTagRemoved($event)"
            (clearFilter)="onClearSearchTags()"
            (refineFilter)="onRefineFilter()">
        </lm-list-searchtags>
    }
</ng-template>

<div #modalPlaceholder id="modalPlaceholder"></div>

<!-- Placeholder required by popupmenu to be used for the collapsed list -->
<ul soho-popupmenu id="{{ listSpec?.busListSpec?.id }}_collapsed_menu"></ul>

@if (listSpec?.busListSpec?.attachmentListInfo) {
    @if (listSpec.busListSpec.attachmentListInfo.hasCreateAction) {
        <input #attachmentFileInput
            attr.data-automation-id="lm-{{screenAutomationId}}-file-input"
            type="file"
            multiple="true"
            id="{{ listSpec?.busListSpec?.id }}_fileInput"
            style="display:none;"
            (change)="attachmentListFileInputChange()"
        />
    }
    @if (!listSpec.busListSpec.attachmentListInfo.disableDownload) {
        <a #standardDownloadAction id="{{ listSpec?.busListSpec?.id }}_downloadAnchor" style="display:none;"></a>
    }
}
